import { Form, Radio } from '~src/components/display';
import { ConsumptionProfileGraph } from '~src/components/display/graphs/ConsumptionProfileGraph';
import { useLocalization } from '~src/hooks';
import { ConsumptionProfile, MonthlyConsumptionProfile } from '~src/types';
import {
  consumptionProfiles,
  DEFAULT_CONSUMPTION_PROFILE_KEY,
  DEFAULT_MONTHLY_CONSUMPTION_PROFILE_KEY,
  monthlyConsumptionProfiles,
} from '~src/utilities/constants';

import { consumptionProfileFieldKey, monthlyConsumptionProfileFieldKey } from '../constants';
import { getConsumptionProfileOptions, getMonthlyConsumptionProfileOptions } from '../helpers/residenceHelper';
import { ResidenceFormSection } from './ResidenceFormSection';

import { displayColumn } from '~src/style/shared.module.css';

import { consumptionProfileSection } from './residenceFormComponents.module.css';

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];

export const ResidenceFormConsumptionProfile = () => {
  const translate = useLocalization();

  const form = Form.useFormInstance();

  const formConsumptionProfile = Form.useWatch(consumptionProfileFieldKey, form) as ConsumptionProfile | undefined;

  const consumptionProfileOptions = getConsumptionProfileOptions(translate);

  const consumptionGraphData = consumptionProfiles[formConsumptionProfile ?? DEFAULT_CONSUMPTION_PROFILE_KEY].map(
    (energyExpenditure, index) => ({
      timeKey: `${index}:00`,
      energyExpenditure,
    })
  );

  const formMonthlyConsumptionProfile = Form.useWatch(monthlyConsumptionProfileFieldKey, form) as
    | MonthlyConsumptionProfile
    | undefined;

  const monthlyConsumptionProfileOptions = getMonthlyConsumptionProfileOptions(translate);

  const monthlyConsumptionGraphData = monthlyConsumptionProfiles[
    formMonthlyConsumptionProfile ?? DEFAULT_MONTHLY_CONSUMPTION_PROFILE_KEY
  ].map((energyExpenditure, index) => ({
    timeKey: MONTH_NAMES[index],
    energyExpenditure,
  }));

  return (
    <>
      <ResidenceFormSection title={translate.CONSUMPTION_PATTERN}>
        <div className={consumptionProfileSection}>
          <Form.Item name={consumptionProfileFieldKey}>
            <Radio.Group className={displayColumn} options={consumptionProfileOptions} />
          </Form.Item>

          <ConsumptionProfileGraph data={consumptionGraphData} />
        </div>
      </ResidenceFormSection>

      <ResidenceFormSection title={translate.MONTHLY_CONSUMPTION_PATTERN}>
        <div className={consumptionProfileSection}>
          <Form.Item name={monthlyConsumptionProfileFieldKey}>
            <Radio.Group className={displayColumn} options={monthlyConsumptionProfileOptions} />
          </Form.Item>

          <ConsumptionProfileGraph data={monthlyConsumptionGraphData} />
        </div>
      </ResidenceFormSection>
    </>
  );
};
